import { render } from "./SubscriptionPackages.vue?vue&type=template&id=3fb41aaa"
import script from "./SubscriptionPackages.vue?vue&type=script&lang=js"
export * from "./SubscriptionPackages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__